import React, { useState } from 'react';
import {
  ResizePanel,
  ResizeRow,
  ResizeLabel,
  ResizeInput,
  ResizeUnit,
  ResizeLockRow,
  ResizeLockCheckbox,
  ResizeLockLabel,
  AdjustActionRow,
  CropActionButton,
} from '../imageCanvasStyles';

const parsePositiveInt = value => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

const ResizeOverlay = ({ theme, selectedTheme, imgRef, onApply, onCancel }) => {
  const shared = { theme, $selectedTheme: selectedTheme };

  const initialW = imgRef?.current?.naturalWidth || 0;
  const initialH = imgRef?.current?.naturalHeight || 0;

  const [ ratio ] = useState(() => (initialH > 0 ? initialW / initialH : 1));
  const [ width, setWidth ] = useState(initialW ? String(initialW) : '');
  const [ height, setHeight ] = useState(initialH ? String(initialH) : '');
  const [ lockAspect, setLockAspect ] = useState(true);

  const wVal = parsePositiveInt(width);
  const hVal = parsePositiveInt(height);
  const isValid = wVal !== null && hVal !== null;

  const handleWidthChange = e => {
    const value = e.target.value;
    setWidth(value);
    if (lockAspect) {
      const num = parsePositiveInt(value);
      if (num !== null) setHeight(String(Math.max(1, Math.round(num / ratio))));
    }
  };

  const handleHeightChange = e => {
    const value = e.target.value;
    setHeight(value);
    if (lockAspect) {
      const num = parsePositiveInt(value);
      if (num !== null) setWidth(String(Math.max(1, Math.round(num * ratio))));
    }
  };

  const handleApply = () => {
    if (!isValid) return;
    const img = imgRef?.current;
    if (!img) return;

    const canvas = document.createElement('canvas');
    canvas.width = wVal;
    canvas.height = hVal;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, wVal, hVal);
    onApply(canvas.toDataURL('image/png'));
  };

  return (
    <ResizePanel {...shared}>
      <ResizeRow>
        <ResizeLabel {...shared} htmlFor='resize-width'>Width</ResizeLabel>
        <ResizeInput
          {...shared}
          id='resize-width'
          type='number'
          min='1'
          step='1'
          value={width}
          onChange={handleWidthChange}
        />
        <ResizeUnit {...shared}>px</ResizeUnit>
      </ResizeRow>
      <ResizeRow>
        <ResizeLabel {...shared} htmlFor='resize-height'>Height</ResizeLabel>
        <ResizeInput
          {...shared}
          id='resize-height'
          type='number'
          min='1'
          step='1'
          value={height}
          onChange={handleHeightChange}
        />
        <ResizeUnit {...shared}>px</ResizeUnit>
      </ResizeRow>
      <ResizeLockRow>
        <ResizeLockCheckbox
          {...shared}
          id='resize-lock'
          checked={lockAspect}
          onChange={e => setLockAspect(e.target.checked)}
        />
        <ResizeLockLabel {...shared} htmlFor='resize-lock'>Keep aspect ratio</ResizeLockLabel>
      </ResizeLockRow>
      <AdjustActionRow>
        <CropActionButton onClick={onCancel}>Cancel</CropActionButton>
        <CropActionButton $primary onClick={handleApply} disabled={!isValid}>Apply</CropActionButton>
      </AdjustActionRow>
    </ResizePanel>
  );
};

export { ResizeOverlay };
